export default __webpack_public_path__ + "static/media/logo.f1a6da3d.svg";